module.exports = __webpack_public_path__ + "img/shared9.6731107b.png";